<!-- <FormRadio> Радио баттон </FormRadio> -->

<template>
  <label class="form-radio"
    :class="classes">
    <input v-bind="$attrs"
      :id="id"
      class="form-radio__input"
      type="radio"
      :name="name"
      :value="value">
    <div class="form-radio__box">
      <div :id="check2"
        class="form-radio__in-box" />
    </div>
    <div class="form-radio__text"
      :id="check1">
      <slot />
    </div>
  </label>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  props: {
    name: {
      type: String,
      default: "checkName",
    },
    id: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        "_is-dark": props.isDark,
      })),
    };
  },
  computed: {
    check1() {
      return this.checked ? "checked1" : "";
    },
    check2() {
      return this.checked ? "checked2" : "";
    },
  },
};
</script>

<style lang="scss">
#checked1 {
  color: $color_orange-50;
  background-color: $white;
}

.form-radio {
  $that: &;

  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 19px;
  user-select: none;
  cursor: pointer;

  &__input {
    @include visually-hidden;

    /*    &:checked {
          &+#{$that}__box {
            border-color: #f4691b;

            #{$that}__in-box {
              opacity: 1;
              background-color: #f4691b;
            }
          }
        }*/
  }

  &__text {
    text-transform: uppercase;
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    transition: color 0.25s ease;
    border: 1px solid $color_grey-15;
    padding-left: 28px;
    padding-right: 28px;
    height: 46px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    background-color: $color_dark-90;

    ._is-dark & {
      color: $white;
    }

    #{$that}:hover & {
      color: $color_primary;
    }

    @include phone {
      height: 32px;
      font-size: 12px;
      line-height: 120%;
      padding: 6px 12px;
      margin-top: 0;
    }
  }

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
